import { grayShadeWithSoftBlue, greenShadeColor, redStrongColor } from "../../../config/ColorObj";
import { getChallanFormattedDate } from "../../../utils/dateFormat";

// ── Transform: one API record → ChallanCard-ready shape ──────────────────────

export const transformChallan = (apiItem) => {
    const statusKey =
        apiItem.statusValue ?? "Pending";

    const beatDisplay = apiItem.beatNames
        ? apiItem.beatNames.split(",").map((b) => b.trim()).join(" · ")
        : "-";



    // Revenue colour
    const revenueColor = apiItem.revenue > 0 ? greenShadeColor : grayShadeWithSoftBlue;

    const getStatusTagColor = (status) => {
        switch (status?.toLowerCase()) {
            case "pending":
                return "red";

            case "closed":
                return "brown";

            case "active":
                return "green";

            default:
                return "gray";
        }
    };

    // Four tag chips shown in the card header
    const tags = [
        `${apiItem.qty % 1 === 0 ? apiItem.qty.toFixed(0) : apiItem.qty.toFixed(2)} units loaded`,
        `${apiItem.productCount} Product${apiItem.productCount !== 1 ? "s" : ""}`,
        `Amt: ${apiItem.challanAmt.toFixed(2)}`,
        apiItem.settleDate && apiItem.settleDate !== "-"
            ? `Settled: ${getChallanFormattedDate(apiItem.settleDate)}`
            : apiItem.statusValue,
    ];

    const tagColors = [
        "blue",
        "purple",
        "orange",
        apiItem.settleDate && apiItem.settleDate !== "-"
            ? "green"
            : getStatusTagColor(apiItem.statusValue),
    ];

    return {
        // identity
        id: apiItem.transferNo,   // shown as card title "# TR-2627-006"
        rawId: apiItem.id,           // UUID — used as React key

        // header meta
        created: apiItem.date,
        repName: apiItem.driverName
            ? apiItem.driverName
            : "-",
        beat: beatDisplay,
        status: statusKey,
        statusNumber: apiItem.status,

        // header stats
        revenue: apiItem.revenue > 0
            ? `₹${Number(apiItem.revenue).toFixed(2).toLocaleString("en-IN")}`
            : "₹0.00",
        revenueColor,
        bills: apiItem.billCount,
        progress: apiItem.progress,
        progressColor: (apiItem.progress > 50 ? greenShadeColor : redStrongColor),
        dayDifference: apiItem.dayDifference,
        dayDifferenceColor: apiItem.dayDifference > 10 ? redStrongColor : greenShadeColor,

        // tag chips
        tags,
        tagColors,

        // body — populated when detail API is wired up
        flag: null,
        timeline: null,
        metrics: [],
        details: [],
        products: [],
    };
};